export default "__VITE_ASSET__KFnLx3Ho__"